"use strict";import{getEnableDefaultTooltips as t}from"../InitialConfiguration.js";let e;const l=()=>(e===void 0&&(e=t()),e),a=o=>{e=o};export{l as getEnableDefaultTooltips,a as setEnableDefaultTooltips};
//# sourceMappingURL=Tooltips.js.map
